'use client'

import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined'
import { IconButton, Popover } from '@mui/material'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { useState } from 'react'

interface IEmojiButtonProps {
  onEmojiSelect: (emoji: any) => void
  theme?: string
  disabled?: boolean
}

export const EmojiButton = ({ onEmojiSelect, theme = 'light', disabled = false }: IEmojiButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEmojiSelect = (emoji: any) => {
    onEmojiSelect(emoji)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton size="small" onClick={handleClick} disabled={disabled}>
        <EmojiEmotionsOutlinedIcon sx={{ fontSize: '24px' }} />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Picker
          data={data}
          onEmojiSelect={handleEmojiSelect}
          theme={theme}
          locale="vi"
          previewPosition={'none'}
        />
      </Popover>
    </>
  )
}
